import { useRequest } from 'ahooks'
import { getAdminUserLogin } from '@/api/platform/AdminV1'

import { LoginFormPage } from '@ant-design/pro-components'

const Page = () => {
  const { data, loading } = useRequest(() =>
    getAdminUserLogin({
      redirect_url: `${window.location.origin}/platform/dashboard`,
      platform: window.location.origin === 'https://admin.safepoint.cloud' ? 'chaitin' : 'github',
    }),
  )

  const jumpLog = async () => {
    window.location.href = data?.url!
  }
  return (
    <div
      style={{
        backgroundColor: 'white',
        height: '100vh',
      }}
    >
      <LoginFormPage
        // backgroundImageUrl='https://mdn.alipayobjects.com/huamei_gcee1x/afts/img/A*y0ZTS6WLwvgAAAAAAAAAAAAADml6AQ/fmt.webp'
        backgroundVideoUrl='https://gw.alipayobjects.com/v/huamei_gcee1x/afts/video/jXRBRK_VAwoAAAAAAAAAAAAAK4eUAQBr'
        title={<div style={{ color: '#fff' }}>Safepoint</div>}
        containerStyle={{
          backgroundColor: 'rgba(0, 0, 0,0.65)',
          backdropFilter: 'blur(4px)',
          height: '80vh',
        }}
        mainStyle={{
          height: '80%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        onFinish={async (values) => {
          jumpLog()
        }}
        submitter={{
          searchConfig: {
            submitText: 'Auth Login',
          },
          submitButtonProps: {
            loading,
            size: 'large',
            style: {
              width: '100%',
            },
          },
        }}
      />
    </div>
  )
}

export default Page
